import React, { type ReactNode } from "react";
import { clsx } from "clsx";
import typographyStyles from "@bloomberg/media-ui-tokens/css/typography.module.css";

import { Locale } from "~types/wardenclyffe";
import { isLanguageCodeJa } from "~utils/i18n/isLanguageCodeJa";

import styles from "./ArticleHeadline.module.css";

interface ArticleHeadlineProps {
    children: ReactNode;
    className?: string;
    languageCode?: Locale;
}

export const ArticleHeadline = ({
    children,
    className,
    languageCode = Locale.En,
}: ArticleHeadlineProps) => {
    const isJa = isLanguageCodeJa(languageCode);

    return (
        <h1
            className={clsx(styles.headline, className, {
                [styles.headlineDefaultLocale]: !isJa,
                [typographyStyles.articleHeadlineXl]: isJa,
            })}
            data-component="headline"
        >
            {children}
        </h1>
    );
};
